import { AddCartButtonRequest } from './modal_js_env';

export class AddCartModal {

  /// 通常注文のカゴ投入ボタン押下処理用リクエスト作成
  static createRequestForGetClickCartButtonByNormal(
    targetElement: HTMLElement,
    viewName: string
  ): AddCartButtonRequest {
    const supplierId = targetElement.dataset.supplierId as string;
    const catalogItemCode = targetElement.dataset.catalogItemCode as string;

    var selectValue = 0;

    /// 数量の取得
    if(viewName === "recent_checked") {
      // 最近チェックした商品一覧はタグの階層が異なる為、個別処理を実施
      selectValue = this.fetchRecentCheckedItemSelectValue(targetElement);
    } else {
      selectValue = this.fetchSingleItemSelectValue(targetElement);
    }

    /// サイト区分
    const siteTypeValue = targetElement.dataset.siteTypeValue as string;
    return new AddCartButtonRequest(supplierId, catalogItemCode, selectValue, siteTypeValue);
  }

  private static fetchSingleItemSelectValue(
    targetElement: HTMLElement,
  ): number {
    let inputElement = targetElement.parentElement?.parentElement?.getElementsByTagName('input')[0];
    // 大業パ商品の場合、inputElementが商品の数量ではなく大業パツールチップの「一定期間表示しない」チェックボックスを取得されるため、
    // 正しい階層から商品の数量を再取得
    if (inputElement?.id === "hideCommercialPackCheckbox") {
      inputElement = targetElement.parentElement?.getElementsByTagName('input')[0];
    }
    // テキストボックスの値(10以上の場合の値)を取得
    let inputItemValue = Number(inputElement?.value);
    // プルダウンの値を取得
    let selectedItemValue = Number(targetElement.parentElement?.parentElement?.getElementsByTagName('select')[0].value);

    let inputDefaultValue = Number(inputElement?.min);

    if (selectedItemValue < 10) {
      return selectedItemValue;
    } else if (inputItemValue !== inputDefaultValue) {
      return inputItemValue;
    }
    // いずれも当てはまらない場合、フェールセーフとして1を返却
    return 1;
  }

  /// 最近チェックした商品一覧の数量取得
  private static fetchRecentCheckedItemSelectValue(
    targetElement: HTMLElement,
  ): number {
    var selectValue = Number(targetElement.parentElement?.parentElement?.getElementsByTagName('input')[0].value) ;

    // テキスト入力値がデフォルトの場合は、プルダウンで選択した値を取得
    if(selectValue === 0) {
      selectValue = Number(targetElement.parentElement?.parentElement?.getElementsByTagName('select')[0].value);
    }

    return selectValue;
  }
}
